var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 247.74 183.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6141e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m70.34,12.48v-1.12h7.33v1.12h-7.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.95,10.56v-1.95h2.05v1.95h-2.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m92.1,7.35v-1.53h3.71v1.53h-3.71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103.6,4.61l-.4-1.95V.5h1.44v2.16l-.4,1.95h-.65Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m113.58,4.61l-.4-1.95V.5h1.44v2.16l-.4,1.95h-.65Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.27,13.49V0h1.2v13.49h-1.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m133.52,4.61l-.4-1.95V.5h1.44v2.16l-.4,1.95h-.65Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m143.5,4.61l-.4-1.95V.5h1.44v2.16l-.4,1.95h-.65Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m151.94,7.35v-1.53h3.71v1.53h-3.71Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m162.74,10.56v-1.95h2.05v1.95h-2.05Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m170.07,12.48v-1.12h7.33v1.12h-7.33Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m43.06,28.16v-1.95h2.05v1.95h-2.05Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m52.21,24.95v-1.53h3.71v1.53h-3.71Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.71,22.21l-.4-1.95v-2.16h1.44v2.16l-.4,1.95h-.65Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.27,31.09v-13.49h1.2v13.49h-1.2Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m183.84,19.54l-1.53-2.46v-.04h1.53l1.16,2.51h-1.16Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m191.84,24.95v-1.53h3.71v1.53h-3.71Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m202.63,28.16v-1.95h2.05v1.95h-2.05Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.11,45.76v-1.95h2.05v1.95h-2.05Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.79,39.81l-.4-1.95v-2.16h1.44v2.16l-.4,1.95h-.65Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.93,48.27l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.27,48.69v-13.49h1.2v13.49h-1.2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.46,48.27l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m213.76,37.14l-1.53-2.46v-.04h1.53l1.16,2.51h-1.16Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m222.58,45.76v-1.95h2.05v1.95h-2.05Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.17,63.36v-1.95h2.05v1.95h-2.05Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.84,57.41l-.4-1.95v-2.16h1.44v2.16l-.4,1.95h-.65Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.91,65.87l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.27,66.29v-13.49h1.2v13.49h-1.2Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m189.49,65.87l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m233.71,54.74l-1.53-2.46v-.04h1.53l1.16,2.51h-1.16Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m242.52,63.36v-1.95h2.05v1.95h-2.05Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.04,83.47l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m66.88,83.47l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.27,83.89v-13.49h1.2v13.49h-1.2Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.52,83.47l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m239.36,83.47l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.3,89.94l-1.53-2.46v-.04h1.53l1.16,2.51h-1.16Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.99,101.07l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m76.85,101.07l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.27,101.49v-13.49h1.2v13.49h-1.2Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.54,101.07l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m219.41,101.07l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m233.25,92.61l-.4-1.95v-2.16h1.44v2.16l-.4,1.95h-.65Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m34.25,107.54l-1.53-2.46v-.04h1.53l1.16,2.51h-1.16Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.93,118.67l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m86.82,118.67l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.27,119.09v-13.49h1.2v13.49h-1.2Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m159.57,118.67l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.46,118.67l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m213.31,110.21l-.4-1.95v-2.16h1.44v2.16l-.4,1.95h-.65Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.19,125.14l-1.53-2.46v-.04h1.53l1.16,2.51h-1.16Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m66.88,136.27l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m96.8,136.27l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.27,136.69v-13.49h1.2v13.49h-1.2Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m149.6,136.27l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.52,136.27l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m193.36,127.81l-.4-1.95v-2.16h1.44v2.16l-.4,1.95h-.65Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.42,153.28v-1.11h7.33v1.11h-7.33Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m53.03,151.36v-1.95h2.05v1.95h-2.05Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.18,148.15v-1.53h3.71v1.53h-3.71Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.14,142.74l-1.53-2.46v-.04h1.53l1.16,2.51h-1.16Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m86.82,153.87l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m106.77,153.87l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.27,154.29v-13.49h1.2v13.49h-1.2Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m139.62,153.87l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m159.57,153.87l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m173.42,145.41l-.4-1.95v-2.16h1.44v2.16l-.4,1.95h-.65Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m181.86,148.15v-1.53h3.71v1.53h-3.71Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m192.66,151.36v-1.95h2.05v1.95h-2.05Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.99,153.28v-1.11h7.33v1.11h-7.33Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.98,171.29c-.48.04-.91,0-1.29-.09-.38-.1-.68-.28-.9-.54-.22-.26-.33-.6-.33-1.02v-3.15c0-.29-.12-.51-.35-.64s-.49-.19-.78-.18v-1.16c.25,0,.51-.05.76-.18.25-.13.37-.35.37-.65v-3.14c0-.43.11-.77.34-1.03.22-.25.53-.43.91-.54.38-.1.81-.13,1.28-.08v.75c-.14,0-.29.02-.47.06-.18.04-.33.11-.46.22s-.2.26-.21.47l-.12,3.12c-.02.48-.12.85-.32,1.12-.19.26-.53.4-1.02.4v.13c.49,0,.83.13,1.02.4s.3.64.32,1.11l.12,3.11c0,.21.08.36.21.48s.29.19.46.23.33.06.47.06v.75Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.42,170.88v-1.12h7.33v1.12h-7.33Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.39,170.88v-1.12h7.33v1.12h-7.33Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.37,170.88v-1.12h7.33v1.12h-7.33Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m70.34,170.88v-1.12h7.33v1.12h-7.33Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.31,170.88v-1.12h7.33v1.12h-7.33Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.08,160.34l-1.53-2.46v-.04h1.53l1.16,2.51h-1.16Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m106.77,171.47l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m116.74,171.47l-7.04-12.57h1.33l7.05,12.57h-1.35Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.27,171.89v-13.49h1.2v13.49h-1.2Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m129.65,171.47l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m139.62,171.47l7.05-12.57h1.33l-7.04,12.57h-1.35Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m153.47,163.01l-.4-1.95v-2.16h1.44v2.16l-.4,1.95h-.65Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m160.1,170.88v-1.12h7.33v1.12h-7.33Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m170.07,170.88v-1.12h7.33v1.12h-7.33Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m180.04,170.88v-1.12h7.33v1.12h-7.33Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m190.02,170.88v-1.12h7.33v1.12h-7.33Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.99,170.88v-1.12h7.33v1.12h-7.33Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m211.77,158.9c.49-.05.92-.02,1.3.08s.67.28.89.54c.22.25.33.6.33,1.03v3.15c0,.29.12.51.36.64s.5.19.77.18v1.16c-.25,0-.51.05-.76.18s-.37.35-.37.65v3.14c0,.42-.11.76-.34,1.02-.23.26-.53.44-.9.54s-.8.13-1.28.09v-.75c.14,0,.29-.02.47-.06.18-.04.33-.11.46-.22.13-.11.2-.26.21-.47l.12-3.12c.02-.48.12-.85.31-1.11.19-.26.53-.4,1.02-.4v-.13c-.49,0-.83-.13-1.02-.4-.19-.26-.29-.64-.31-1.12l-.12-3.11c0-.21-.08-.38-.21-.48-.13-.11-.28-.18-.46-.22-.17-.04-.33-.06-.48-.06v-.75Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m114.03,177.94l-1.53-2.46v-.04h1.53l1.16,2.51h-1.16Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m122.02,183.35v-1.53h3.71v1.53h-3.71Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m133.52,180.61l-.4-1.95v-2.16h1.44v2.16l-.4,1.95h-.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShellIcon);
export default __webpack_public_path__ + "static/media/shell-icon.54f5a56243b75a342e37a0b3bfacbf09.svg";
export { ForwardRef as ReactComponent };